export type SharePlatform = 'twitter' | 'facebook' | 'whatsapp';

export interface ShareContent {
  title: string;
  text: string;
  url: string;
}

export function buildShareContent(content: ShareContent): ShareContent {
  return {
    title: content.title || 'Weather update',
    text: content.text || '',
    url: content.url || (typeof window !== 'undefined' ? window.location.origin : ''),
  };
}

export function openShareLink(platform: SharePlatform, content: ShareContent) {
  const encodedText = encodeURIComponent(`${content.title} - ${content.text}`.trim());
  const encodedUrl = encodeURIComponent(content.url);

  const urls: Record<SharePlatform, string> = {
    twitter: `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedText}`,
    whatsapp: `https://wa.me/?text=${encodedText}%20${encodedUrl}`,
  };

  const shareUrl = urls[platform];
  if (shareUrl && typeof window !== 'undefined') {
    window.open(shareUrl, '_blank', 'noopener,noreferrer');
  }
}

export function getQrCodeUrl(url: string): string {
  const target = url || (typeof window !== 'undefined' ? window.location.href : '');
  return `https://quickchart.io/qr?text=${encodeURIComponent(target)}&margin=1&size=240`;
}
